import styles from "./ScholarshipTermsNotice.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const ScholarshipTermsNotice = () => {
  const { t } = useTranslationHook();

  return (
    <div className={styles.termsNoticeContainer}>
      <div className={styles.content}>
        <p className={styles.noticeText}>
          {t("scholarship.termsnotice.checkoutprefix")}{" "}
          <a
            href="/blog/post/study-in-the-uk-with-the-best-scholarship-amberscholar-scholarship"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            <strong>{t("scholarship.termsnotice.termsandconditions")}</strong>
          </a>
        </p>
        <p className={styles.noticeText}>
          {t("scholarship.termsnotice.emailprefix")}{" "}
          <a href="mailto:amberscholar@amberstudent.com" className={styles.emailLink}>
            <strong>{t("scholarship.termsnotice.email")}</strong>
          </a>
        </p>
      </div>
    </div>
  );
};

export default wrapperHOC(ScholarshipTermsNotice, {
  componentName: "ScholarshipTermsNotice-ScholarshipDesktop",
  showForChina: true,
});
